<template lang="pug">
.c-images-editor
  v-btn(@click="$refs.input.click()") 選擇圖片
  v-dialog(v-model="alert")
    v-card
      v-card-text.error--text.text-xs-center.title 最多上傳100張照片
      v-card-actions
        v-spacer
        v-btn(@click="alert = false") 確認
        v-spacer
  input.d-none(ref="input"
    type="file"
    accept="image/*"
    multiple
    @change="upload")
  v-layout(v-if="items.length > 0")
    v-flex
      v-card
        v-container(grid-list-sm
          fluid)
          dnd.layout.row.wrap(:value="items"
            @input="updateItems")
            v-flex(v-for="(item, index) in items"
              :class="$style.item"
              xs4
              sm3
              md2)
              v-card(flat
                tile)
                base-url-provider(:filepath="item.name")
                  template(v-slot="{ url }")
                    v-img(:src="url || $utils.get(item, 'temp.dataURL')"
                      contain)
                div(:class="$style.tool")
                  v-btn(:class="$style.close"
                    fab
                    dark
                    color="error"
                    @click="items.splice(index, 1)")
                    v-icon(dark) close
                  div(:class="$style.index")
                    span {{ index + 1 }}
                  div(:class="$style.edit")
                    v-tooltip(
                      top)
                      template(v-slot:activator="{ on }")
                        v-btn(
                          v-on="on"
                          color="white"
                          outline
                          dark
                          @click="openDia(index)")
                          v-icon edit
                      span {{ item.description || '圖片描述' }}
                  div(:class="$style.bg")
        v-dialog(v-model="dialog"
          max-width="290"
          persistent)
          v-card
            v-card-title 添加圖片描述
            v-card-text
              v-textarea(:value="description"
                @change="updateDescription")
            v-card-actions
              v-btn(color="info"
                outline
                @click="closeDia") 確認
</template>

<script>
import Dnd from "vuedraggable";
import BaseUrlProvider from "@/components/core/BaseUrlProvider.vue";

export default {
  name: "ImagesEditor",
  components: {
    Dnd,
    BaseUrlProvider
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      current: null,
      description: "",
      dialog: false,
      limit: 100,
      alert: false
    };
  },
  methods: {
    closeDia() {
      this.current = null;
      this.description = "";
      this.dialog = false;
    },
    openDia(index) {
      this.current = index;
      this.description = this.items[index].description;
      this.dialog = true;
    },
    updateDescription(e) {
      const items = [].slice().concat(this.items);
      items[this.current].description = e;
      this.$emit("update:items", items);
    },
    updateItems(v) {
      this.$emit("update:items", v || []);
    },
    upload(e) {
      const input = e.target;

      if (input.files) {
        const items = this.items;
        if (input.files.length + items.length < this.limit + 1) {
          for (let file of input.files) {
            const reader = new FileReader();

            reader.onload = e => {
              const dataURL = e.target.result;
              this.items.push({
                temp: {
                  file,
                  dataURL
                }
              });
            };

            reader.readAsDataURL(file);
          }

          this.updateItems(items);
        } else {
          this.alert = true;
        }
      }
    }
  }
};
</script>

<style module lang="styl">
.item
  position relative
  &:hover
    .tool
      display flex

.tool
  display none
  position absolute
  justify-content space-between
  flex-direction column
  width 100%
  height 100%
  top 0
  left 0
  text-align center
  .index
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    font-size 24px
    font-weight bold
    color white
    z-index 1
.bg
  display block
  position absolute
  width 100%
  height 100%
  top 0
  left 0
  background-color black
  opacity .4

.close
  position relative
  top 0%
  left 70%
  width 25px
  height 25px
  z-index 1

.edit
  z-index 1
</style>
